import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CollectionAddPaymentDetailsPopupComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{
		onClose: (extraInformation?: unknown) => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<CollectionAddPaymentDetailsPopupComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<CollectionAddPaymentDetailsPopupComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-collection-add-payment-details-popup" */ './collection-add-payment-details-popup',
			{
				moduleId: 'edition-awareness-collection-add-payment-details-popup',
			},
		),
		getPreloadProps: () => ({
			entryPoints: {},
			extraProps: {},
			queries: {},
		}),
	});
